import i18n from "@/plugins/i18n";
import _ from "lodash";
import * as moment from "moment/moment";


/**
 * Method which checks for numeric value
 * prevents entering non numeric values
 */
export const isNumberValidator = evt => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
    evt.preventDefault();
  } else {
    return true;
  }
};

export function doubleDigit(num) {
  return num < 10 ? "0" + num : num;
}
export function getFormattedDate(date){
  return moment.utc(date).local().format('dd-MM-yyyy hh:mm');
}

/**
 * Method which return date format in yyyy/mm/dd
 */
export function dateOrTime(dateString, type) {
  
  /* check for ie 11 */

  if (dateString == null || dateString == "") {
    return "";
  }
  dateString = ieDateTimeFormat(dateString);
  const date = new Date(dateString);
  switch (type) {
    case "date":
      return (
        date.getFullYear() +
        "-" +
        doubleDigit(date.getMonth() + 1) +
        "-" +
        doubleDigit(date.getDate())
      );
    case "hourMinute":
      return (
        doubleDigit(date.getHours()) + ":" + doubleDigit(date.getMinutes())
      );
    case "month": {
      return date.getMonth() + 1;
    }
    case "year": {
      return date.getFullYear();
    }
    case "hours": {
      return doubleDigit(date.getHours());
    }
    case "minutes": {
      return doubleDigit(date.getMinutes());
    }
    default:
      return "";
  }
}

export function ieDateTimeFormat(dateString) {
  let usa = window.navigator.userAgent;
  let trident = usa.indexOf("Trident/");
  if (trident > 0) {
    dateString = moment(dateString).format("YYYY-MM-DDTHH:MM:SS");
    dateString = String(dateString);
    /* if (dateString.includes(" ")) {
      dateString = dateString.replace(" ", "T");
      return dateString;
    } */
    return dateString;
  } else {
    return dateString;
  }
}


export function toggleActiveClass(addRemoveClass, className) {
  const element = document.getElementsByClassName(className)[0];
  if (addRemoveClass === "addClass") {
    element.parentElement.classList.add("active");
  } else {
    element.parentElement.classList.remove("active");
  }
}

export function readACL(unitID) {
  return _.pick(JSON.parse(localStorage.getItem("acl")), [unitID]);
}

export function getSideMenu(menus,permissions,action){
  menus = JSON.parse(JSON.stringify(menus));
  permissions = JSON.parse(JSON.stringify(permissions));
  menus = _.filter(menus,function(menu){
    if(!menu.module){
      return true;
    }
    let permission = _.find(permissions, function(permission){
       return permission.module.name == menu.module; 
    });
    if(!action && permission.action!==3){
      return true;
    }
    if(action && permission.action==action){
      return true;
    }
    return false;
  })
  return menus;
}

export function isPermissionEnabled(module,action,checkHidden=false){
  let loggedInUser = JSON.parse(localStorage.getItem("user"));
  let permission = _.find(loggedInUser.role.permissions, function(permission){
    return permission.module.name == module; 
  });
  if(!checkHidden && permission.action == action){
    return true;
  }
  if(checkHidden){
    if(permission.action == 1 || permission.action == 2 ){
      return true;
    }
  }
  return false;
}

export function checkChildrenACL(menu) {
  const submenus = [];
  _.forEach(menu, function(submenu) {
    if (submenu.uID) {
      const subMenuRule = readACL(submenu.uID);
      if (subMenuRule[submenu.uID]) {
        submenus.push(submenu);
      }
    } else {
      submenus.push(submenu);
    }
  });
  return submenus;
}

/*
 * Method which accepts only numeric values
 */
export function onlyNumber($event) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
    $event.preventDefault();
  }
}
export function onlyNumberWithOutDot($event) {
  let keyCode = $event.keyCode ? $event.keyCode : $event.which;
  if ((keyCode < 48 || keyCode > 57)) {
    $event.preventDefault();
  }
}

export default {
  showCancelButton: false,
  confirmButtonText: i18n.t("CLOSE"),
  cancelButtonText: i18n.t("CANCEL"),
  confirmButtonColor: "#ac000c",
  cancelButtonColor: "#aaa",
  buttonsStyling: true,
  customClass: {
    confirmButton: "btn btn-primary px-4 mr-2",
    cancelButton: "btn  px-4 mr-2"
  },
  width: 400,
  padding: "3em"
};

export function calculatePercentage(number, percentage){  
  return parseFloat((number*(percentage/100)).toFixed(4));
}

export function removeComma(numberString){
  if (typeof numberString === "string" && numberString.indexOf(',') > -1) {
    return numberString.replace(/,/g, ''); 
  }   else {
    return numberString;
  }
  
}


// WEBPACK FOOTER //
// ./src/shared/utils.js